var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "group-plans": true, mobile: _vm.isMobile(_vm.$mq) } },
    [
      _c("div", { staticClass: "group-details" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "router-link",
              {
                directives: [
                  {
                    name: "track",
                    rawName: "v-track:click",
                    value: { axId: "clicked_groupsales_plans_back" },
                    expression: "{ axId: 'clicked_groupsales_plans_back' }",
                    arg: "click"
                  }
                ],
                staticClass: "back",
                attrs: { to: { name: "payment_brilliant_square_plans" } }
              },
              [
                _c("span", { staticClass: "b-sprite-paywall-chevron inline" }),
                _vm._v("\n        Back\n      ")
              ]
            ),
            _vm._v(" "),
            _vm.cannot_purchase_reason
              ? _c("header", [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm.cannot_purchase_reason.startsWith("User already belongs")
                    ? _c("h3", [
                        _vm._v(
                          "\n          You're already in a Brilliant Premium group\n        "
                        )
                      ])
                    : _c("h3", [_vm._v(_vm._s(_vm.cannot_purchase_reason))])
                ])
              : _c(
                  "header",
                  { staticClass: "group-sales" },
                  [
                    _c("GroupPaywallIllustration"),
                    _vm._v(" "),
                    _c("h1", [_vm._v("Learn better, together")]),
                    _vm._v(" "),
                    _c("h2", [
                      _vm._v(
                        "\n          Group plans start at just " +
                          _vm._s(
                            _vm.monthly_price_minimum_seats_per_seat.for_display
                          ) +
                          "/month\n          "
                      ),
                      _c("span", { staticClass: "nowrap" }, [
                        _vm._v("per person")
                      ]),
                      _vm._v(".\n        ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "Button",
                      {
                        directives: [
                          {
                            name: "track",
                            rawName: "v-track:click",
                            value: {
                              axId: "clicked_groupsales_plans_subscribe_main"
                            },
                            expression:
                              "{ axId: 'clicked_groupsales_plans_subscribe_main' }",
                            arg: "click"
                          }
                        ],
                        attrs: { primary: "", green: "" },
                        on: {
                          click: function($event) {
                            _vm.showModal = true
                          }
                        }
                      },
                      [_vm._v("\n          Subscribe now\n        ")]
                    )
                  ],
                  1
                ),
            _vm._v(" "),
            _vm.showModal
              ? _c(
                  "Modal",
                  {
                    staticClass: "group-plans-modal",
                    attrs: { scrollable: _vm.isModalScrollable() },
                    on: {
                      close: function($event) {
                        _vm.showModal = false
                      }
                    }
                  },
                  [
                    _c("GroupPlansModalContent", {
                      on: {
                        close: function($event) {
                          _vm.showModal = false
                        },
                        "new-purchase-order": _vm.handlePurchaseOrder
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.cannot_purchase_reason
              ? _c("ul", { staticClass: "qa unstyled" }, [
                  _c("li", [
                    _c("h4", [
                      _vm._v("How many members can I have in my group?")
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n            Brilliant Premium group plans can accommodate " +
                          _vm._s(_vm.seat_count_minimum) +
                          " to\n            " +
                          _vm._s(_vm.seat_count_maximum) +
                          " people. For even larger groups,\n            "
                      ),
                      _c(
                        "a",
                        { attrs: { href: "mailto:support@brilliant.org" } },
                        [_vm._v("contact us")]
                      ),
                      _vm._v(".\n          ")
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _vm._m(3)
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("PageContent", { staticClass: "page-content" }),
      _vm._v(" "),
      _c("PaywallFooterCta", {
        staticClass: "paywall-section",
        attrs: { "cta-text": "View plans" },
        on: {
          "footer-cta-clicked": function($event) {
            _vm.showModal = true
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [
      _vm._v("Annual Plan "),
      _c("span", { staticClass: "nowrap" }, [_vm._v("for Groups")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("h4", [_vm._v("Do we all have to share accounts?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("No, everyone gets their own individual Premium account.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("h4", [_vm._v("How does the payment work?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            Each group plan will be processed as one payment every year. You can cancel at any\n            time.\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("h4", [_vm._v("Can I add and remove people in my plan?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            If you remove a member of your group, an additional spot will open up in your plan. We\n            don't currently support adding additional members to a full group plan in the middle\n            of a subscription, but you can always add more seats when you renew.\n          "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }